export enum PanDrawerCodes {
    HIGH_SIDES = 'PDSIDES',
    FROSTED_SIDES = 'PDUPGRADEGLASS'
}